module.exports = __webpack_public_path__ + "static/aspire-c9763c566e7efb96cd507b99125f8b66.svg";